<template>
  <section :class="warpClass" :style="`background-color: ${backgroundColor}`">
    <div :class="(compProps.mode === mode.swiperCol ? 'swiper-wrapper wrapper-width' : '')">
      <div
        :class="(compProps.mode === mode.swiperCol ? 'swiper-slide' : '')"
        data-actionid="3"
        :data-itemtext="item.unitName"
        :data-itemotherinfo="item.unitId"
        @click="openHouseInfo($event, item.unitId, index)"
        class="house-warp"
        v-for="(item, index) in compProps.items"
        :key="item.unitId"
        data-growing-container
      >
        <div v-if="compProps.mode === mode.singleCol || compProps.mode === mode.singleCommentCol" class="house-imgs-warp swiper-container">
          <!-- <img v-if="compProps.privateProps&&compProps.privateProps.atmosphere" class="atmosphere-icon" :src="compProps.privateProps&&(picHost + compProps.privateProps.atmosphere)"> -->
          <!-- <img v-if="item.promotionPicUrl" class="atmosphere-icon" :src="item.promotionPicUrl"> -->
          <div class="swiper-wrapper">
            <div v-for="(image) in item.pictureList" :key="image" class="swiper-slide">
              <img width="100%" v-lazy="image" @error="imgErrorHandle" class="tjf-img-bg">
            </div>
          </div>
        </div>
        <!-- 筛选项内的房屋卡片目前使用的渲染方式 -->
        <div v-else class="house-imgs-warp">
          <!-- <img v-if="compProps.privateProps&&compProps.privateProps.atmosphere" class="atmosphere-icon" :src="compProps.privateProps&&(picHost + compProps.privateProps.atmosphere)"> -->
          <!-- <img v-if="item.promotionPicUrl" class="atmosphere-icon" :src="item.promotionPicUrl"> -->
          <!-- <div>
            <img width="100%" :src="item.defaultPicture" @error="imgErrorHandle">
          </div>-->
          <div class="multi-imgs-container">
            <!-- 3张图模式 -->
            <div v-if="imgShowNumInterval[index % imgShowNumInterval.length] === 3" class="three-imgs-wrapper">
              <div class="img-column img-column--main">
                <img width="100%" v-lazy="item.pictureList[0]" @error="imgErrorHandle" class="tjf-img-bg">
              </div>
              <div class="img-column img-column--right">
                <div class="img-wrapper">
                  <img width="100%" v-lazy="item.pictureList[1]" @error="imgErrorHandle" class="tjf-img-bg">
                </div>
                <div class="img-wrapper img-wrapper-bottom">
                  <img width="100%" v-lazy="item.pictureList[2]" @error="imgErrorHandle" class="tjf-img-bg">
                </div>
              </div>
            </div>
            <!-- 5张图模式 -->
            <div v-else class="five-imgs-wrapper">
              <div class="img-row img-row-1">
                <div class="img-wrapper img-wrapper--main">
                  <img width="100%" v-lazy="item.pictureList[0]" @error="imgErrorHandle" class="tjf-img-bg">
                </div>
                <div class="img-wrapper">
                  <img width="100%" v-lazy="item.pictureList[1]" @error="imgErrorHandle" class="tjf-img-bg">
                </div>
              </div>
              <div class="img-row">
                <div class="img-column-left">
                  <div class="img-wrapper">
                    <img width="100%" v-lazy="item.pictureList[2]" @error="imgErrorHandle" class="tjf-img-bg">
                  </div>
                  <div class="img-wrapper">
                    <img width="100%" v-lazy="item.pictureList[3]" @error="imgErrorHandle" class="tjf-img-bg">
                  </div>
                </div>
                <div class="img-column-right">
                  <div class="img-wrapper">
                    <img width="100%" v-lazy="item.pictureList[4]" @error="imgErrorHandle" class="tjf-img-bg">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="house-detail-warp">
          <div class="house-detail-tags" v-if="item.hasSpecialTags">
            <div class="detail-tag-1" v-for="(item) in item.specialTags" :key="item.name">{{item.name}}</div>
          </div>
          <div class="house-detail-name" :class="unitNameClass">{{item.unitName}}</div>
          <div class="house-detail-unit">
            <label v-for="summer in item.unitSummeries" :key="summer.text">{{ summer.text }}</label>
          </div>
          <div v-if="item.finalPrice" class="house-detail-price">
            <div class="detail-price-now">￥{{item.finalPrice}}</div>
            <div class="detail-price-before" v-if="item.finalPrice < item.productPrice">￥{{item.productPrice}}</div>
            <div class="detail-price-reason">
              <label v-for="tag in item.priceTags" :key="tag.text">{{tag.text || tag.name }}</label>
              <label v-if="item.priceTags.length <= 0 &&item.hasPriceTags" style="background-color: transparent;">{{' '}}</label>
              <label v-if="item.promotionDesc">优惠{{item.promotionDesc}}</label>
            </div>
          </div>
          <div v-else class="house-detail-empty">
            <div class="detail-empty-text">当日已订完</div>
            <div class="detail-price-reason">
              <label v-if="item.hasPriceTags" style="background-color: transparent;">{{' '}}</label>
            </div>
          </div>
          <div v-if="compProps.mode === mode.singleCommentCol" class="house-detail-desc">{{item.comment}}</div>
        </div>
        <div
          v-if="promotionId !== 'T20190108142924' && promotionId !== 'T20190118154654'"
          class="favorate-icon"
          :style="`background-image: url('${baseUrl === '/'?'':baseUrl}${item.isLike?'/static/imgs/favorate.png': '/static/imgs/unfavorate.png'}')`"
          @click.stop="favorite(item.unitId, item.isLike, index, item)"
        ></div>
      </div>
      <div v-if="hasLoadMore()" class="load-more-wrapper">
        <div v-if="!isLoading" class="load-btn-wrapper">
          <div class="load-btn" @click="loadMore">加载更多</div>
        </div>
        <div v-else class="load-tip">
          <cube-loading :size="24"></cube-loading>
          <!-- <div class="load-tip-desc">加载中</div> -->
        </div>
      </div>
      <div v-else class="houses-num-tip">
        <div v-if="compProps.items && compProps.items.length > 0" class="no-more-tip">最后一个了~</div>
        <div v-else class="no-house-tip">
          <img class="no-house-img" v-lazy="`${baseUrl}static/imgs/group.png`" alt>
          <div>
            <p class="no-house-text">没有找到合适的房源</p>
            <p class>修改筛选条件,重新试试吧</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {
          mode: '0',
          items: [],
          totalCount: 0,
          privateProps: {},
          pageIndex: 1
        }
      }
    }
  },
  data() {
    return {
      mode: {
        singleCol: '0',
        singleCommentCol: '1',
        doubleCol: '2',
        swiperCol: '3'
      },
      imgShowNumInterval: [3, 3, 3, 5, 3, 3, 5, 5],
      isLoading: false
    }
  },
  computed: {
    warpClass() {
      switch (this.compProps.mode + '') {
      case '0':
        return 'single-col'
      case '2':
        return 'double-col'
      case '3':
        return 'swiper-col swiper-container'
      case '1':
        return 'single-comment-col'
      default:
        return 'single-col'
      }
    },
    unitNameClass() {
      switch (this.compProps.mode + '') {
      case '1':
        return 'multi-unit'
      default:
        return 'single-unit'
      }
    },
    backgroundColor() {
      if (this.compProps.privateProps) {
        return this.compProps.privateProps.backgroundColor
      } else {
        return ''
      }
    },
    promotionId() {
      return this.$root.promotionId
    }
  },
  watch: {
    compProps: {
      handler(newVal, oldVal) {
        const newArr = JSON.stringify(newVal.items)
        const oldArr = JSON.stringify(oldVal.items)
        if (newArr !== oldArr && (newVal.mode === '0' || newVal.mode === '1')) {
          this.$nextTick(() => {
            // eslint-disable-next-line
            this.swiper = new Swiper(`#comp_id_${this.compId} .house-imgs-warp`, {})
          })
        } else if (newArr !== oldArr && newVal.mode === '3') {
          this.$nextTick(() => {
            let space = 0
            const width = document.body.clientWidth
            if (width <= 720) {
              space = width / 375 * 20
            } else {
              space = 40
            }
            // eslint-disable-next-line
            this.swiper = new Swiper(`#comp_id_${this.compId} .swiper-col`, {
              slidesPerView: 'auto',
              spaceBetween: space
            })
          })
        } else if (newVal.items.length > oldVal.items.length) {
          this.isLoading = false
        }
      },
      deep: true
    }
  },
  methods: {
    imgErrorHandle($event) {
      $event.target.src = `${this.baseUrl}static/imgs/default.jpg`
    },
    openHouseInfo($event, unitId, index) {
      this.$emit('action', { type: 'openHouseInfo', data: unitId, houseIndex: index })
    },
    favorite(unitId, isLike, index, item) {
      this.$emit('action', { type: 'favoriteHouse', data: { id: unitId, isLike: isLike, houseIndex: index, itemData: item } })
    },
    hasLoadMore() {
      const items = this.compProps.items || []
      const maxShowNumber = this.compProps.maxShowNumber
      const pageSize = this.compProps.pageSize
      let pageIndex = this.compProps.pageIndex
      let totalCount = this.compProps.totalCount
      let hasLoadMore = true
      if(
        totalCount/pageSize>pageIndex && 
        items.length < totalCount &&
        items.length < maxShowNumber
      ) {
        hasLoadMore = true
      } else {
        hasLoadMore = false
      }
      return hasLoadMore
    },
    loadMore($event) {
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
      }, 3000)
      this.$emit('action', {
        type: 'loadMore',
        data: { pageIndex: this.compProps.pageIndex + 1 }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.house-warp {
  position: relative;
}

.single-comment-col,
.single-col {
  padding: 0.6666rem 0 0;
  overflow: hidden;
  .house-warp {
    margin: 0 0 1.25rem;
  }
}

.double-col {
  padding: 0.6666rem 0.5rem 0;
  > div {
    display: flex;
    justify-content: space-between;
    flex-flow: wrap;
  }

  .unfavorate-icon,
  .favorate-icon {
    width: 1.25rem;
    height: 1.25rem;
  }

  .house-warp {
    width: 50%;
    padding: 0 0.5rem 1rem;
    box-sizing: border-box;
  }

  .house-detail-unit,
  .house-detail-tags {
    display: none;
  }
  .house-detail-price,
  .house-detail-empty {
    flex-wrap: wrap;
    margin-bottom: 0;
  }
  .detail-price-reason {
    flex-shrink: 0;
    margin-top: 4px;
    width: 100%;
    > label {
      flex-shrink: 0;
    }
  }
  .house-detail-desc {
    display: none;
  }
}

.swiper-col {
  padding: 0.6666rem 1.3333rem 1rem 1.3333rem;
  :global(.swiper-slide) {
    width: 19.8rem;
  }
}

.house-imgs-warp {
  position: relative;
  overflow: hidden;
  border-radius: 0.4rem 0.4rem 0 0;
  background: #fff;
  > div {
    font-size: 0;
  }

  .multi-imgs-container {
    .three-imgs-wrapper {
      display: flex;
      flex-direction: row;

      .img-column--main {
        flex: 1 1 auto;
        width: 29.8rem;
        height: 10.1rem;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .img-column--right {
        display: flex;
        flex-direction: column;
        margin-left: 2px;
        height: 10.1rem;

        .img-wrapper {
          width: 7.4rem;
          height: 5rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        // .img-wrapper-bottom {
        //   height: 75.5px;
        // }
        .img-wrapper:first-child {
          margin-bottom: 2px;
        }
      }
    }
    .five-imgs-wrapper {
      display: flex;
      flex-direction: column;

      .img-row:first-child {
        margin-bottom: 2px;
        height: 151px;
      }
      .img-row {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 75px;

        .img-column-left {
          flex: 2 1 0;
          display: flex;
        }
        .img-column-right {
          margin-left: 2px;
          flex: 1 1 0;

          .img-wrapper {
            height: 100%;
          }
        }

        .img-wrapper {
          // flex: 1 1 auto;
          flex: 1 1 0;
          margin-left: 2px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .img-wrapper:first-child {
          margin-left: 0;
        }
      }
      .img-row-1 {
        .img-wrapper {
          flex: 1 1 0;
        }
        .img-wrapper--main {
          flex: 2 1 0;
        }
      }
    }
  }
}

.atmosphere-icon {
  position: absolute;
  left: 0;
  bottom: 1rem;
  z-index: 9;
  height: 1.4rem;
}

.unfavorate-icon,
.favorate-icon {
  position: absolute;
  width: 2rem;
  height: 2rem;
  z-index: 8;
  background-size: contain;
  background-repeat: no-repeat;
  top: 1rem;
  right: 1rem;
}

.house-detail-warp {
  overflow: hidden;
  background-color: #fff;
  padding: 1rem;
  border-radius: 0 0 0.4rem 0.4rem;
}

.detail-tag-1 {
  color: #ff6666;
  letter-spacing: 0;
  font-size: 10px;
  background-color: #feeded;
  border-radius: 2px;
  padding: 2px 3px;
  margin: 0 5px 2px 0;
  white-space: nowrap;
}

.detail-tag-2 {
  color: #f09e4f;
  letter-spacing: 0;
  font-size: 10px;
  background-color: #fff0d8;
  border-radius: 2px;
  padding: 2px 3px;
  margin-right: 5px;
  white-space: nowrap;
}

.house-detail-name {
  margin-bottom: 0.4rem;
  color: #333;
  letter-spacing: 0;
  font-weight: bold;
  font-size: 16px;
  &.single-unit {
    line-height: 1.2;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.house-detail-unit {
  margin-bottom: 0.6rem;
  color: #666;
  font-size: 12px;
  letter-spacing: 0px;
  > label {
    margin-right: 5px;
  }
}

.house-detail-tags,
.house-detail-price,
.house-detail-empty {
  display: flex;
  margin-bottom: 0.4rem;
  align-items: flex-end;
}

.detail-empty-text {
  height: 19px;
  font-size: 14px;
  color: #ff7248;
}

.house-detail-tags {
  flex-wrap: wrap;
  height: 16px;
  overflow: hidden;
}

.house-detail-price {
  margin-bottom: 0rem;
}

.detail-price-now {
  color: #333;
  font-size: 18px;
  letter-spacing: 0;
  font-weight: 700;
  margin-right: 5px;
  /* 处理人民币钱符没有左对齐 */
  margin-left: -2px;
}

.detail-price-before {
  color: #999;
  font-size: 12px;
  letter-spacing: -1.2px;
  text-decoration: line-through;
  margin-right: 0.7rem;
  line-height: 1rem;
  height: 1rem;
}

.detail-price-reason {
  display: flex;
  > label {
    color: #ff6666;
    font-size: 10px;
    background-color: #feeded;
    border-radius: 2px;
    letter-spacing: 0;
    padding: 2px 10px;
    margin-right: 5px;
    display: block;
    line-height: 16px;
    height: 18px;
    box-sizing: border-box;
  }
}

.house-detail-desc {
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0;
  color: #999;
  padding-top: 0.6rem;
}
/* 加载更多按钮 */
.load-more-wrapper {
  margin-top: 20px;
  margin-bottom: 40px;
  width: 100%;

  .load-btn-wrapper {
    display: flex;
    justify-content: center;
    .load-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 2.7rem;
      width: 15rem;
      height: 2.7rem;
      background: #f4f6f8;
      font-size: 16px;
      color: #464646;
    }
  }

  .load-tip {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 36px;
  }
  .load-tip-desc {
    font-size: 16px;
  }
}
/* 房屋数量相关提示 */
.houses-num-tip {
  width: calc(100% + 30px);
  margin-left: -15px;
  .no-more-tip {
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #333;
    font-size: 14px;
  }
  .no-house-tip {
    display: flex;
    padding: 4.4rem 0;
    justify-content: center;
    align-items: center;
    p {
      color: #d7d7d7;
      font-size: 12px;
    }
    .no-house-text {
      padding-bottom: 0.5rem;
      font-size: 16px;
    }
  }
  .no-house-img {
    margin-right: 0.6rem;
    width: 2.2rem;
    height: 2.2rem;
  }
}
</style>
